import { Box, Button, CircularProgress } from "@mui/material";
import { useMemo, useState } from "react";
import { EMode } from "../../../../shared/components/features/event-scheduler/enums/event.enums";
import { EventSchedulerView } from "../../../../shared/components/features/event-scheduler/view/EventSchedulerView";
import { eventSchedulerValidator } from "../../../../quotes/quote-create-stepper/next-prev/validators/eventSchedulerValidator";
import { filledButtonSecondary } from "../../../../ui/styles/buttonStyles";
import { useJobEventEditMutation } from "./hooks/useJobEventEditMutation";

interface Props {
  jobEventUid: string;
}

export const JobsEventsEdit = ({ jobEventUid }: Props) => {
  const [evenSchedulerState, setEvenSchedulerState] = useState(null);
  const { editJobEvent, isLoading } = useJobEventEditMutation(jobEventUid);

  const canEdit = useMemo(() => eventSchedulerValidator(evenSchedulerState), [evenSchedulerState]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <EventSchedulerView
        onPayloadChange={(e: any) => setEvenSchedulerState(e)}
        multipleDates={false}
        disabledForms={["hourly", "eachNDays", "eachNHours", "eachNMinutes"]}
        disableJsonPayload
        canSkip={false}
        enabledModes={[EMode.SINGLE_EXECUTION]}
      />

      <Button
        variant="contained"
        size="small"
        sx={{ ...filledButtonSecondary, alignSelf: "center", mt: 2, minWidth: 120 }}
        onClick={() => editJobEvent(evenSchedulerState)}
        disabled={isLoading || !canEdit}
      >
        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Edit"}
      </Button>
    </Box>
  );
};
